// import React, { useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import styles from "../CommonStyles/commonstylesDetails.module.scss";
// import { useFetchPartnerDetails } from "../../../../hooks/partnerHook/usePartner";
// import { useRemoveLicence } from "../../../../hooks/partnerHook/usePartnerLicence";
// import { RiDeleteBin5Line } from "react-icons/ri";
// import DeleteBox from "../../../../components/DeleteBox/DeleteBox";

// const LicenseDetails = () => {
//   const { licenceId } = useParams();
//   const navigate = useNavigate();
//   const { data: partnerData, isLoading, isError } = useFetchPartnerDetails();

//   const license = partnerData?.partner?.licence?.find(
//     (lic) => lic.licence_id.toString() === licenceId
//   );

//   const {
//     mutate: removeLicense,
//     isSuccess: licenseDeleted,
//     isError: deletionError,
//   } = useRemoveLicence();

//   const [showDeleteModal, setShowDeleteModal] = useState(false);

//   if (isLoading) return <h2>Loading License Details...</h2>;
//   if (isError || !license) return <h2>Error: License not found!</h2>;

//   const handleDelete = () => {
//     if (licenceId) {
//       removeLicense({ partnerId: partnerData.partner.id, licenceId });
//       setShowDeleteModal(false);
//       navigate("/dashboard/licenses");
//     }
//   };

//   return (
//     <div className={styles.detailsContainer}>
//       <div className={styles.titleContainer}>
//         <h2 className={styles.equipmentTitle}>{license.title}</h2>
//         <RiDeleteBin5Line
//           className={styles.deleteIcon}
//           onClick={() => setShowDeleteModal(true)}
//         />
//       </div>

//       <div className={styles.imageCard}>
//         <img
//           src={license.media?.[0]?.media_url || "/default-image.jpg"}
//           alt={license.title}
//           className={styles.equipmentImage}
//         />
//         <span
//           className={`${styles.verificationStatus} ${
//             license.verification_status === "success"
//               ? styles.verified
//               : styles.notVerified
//           }`}
//         >
//           {license.verification_status === "success"
//             ? "Verified"
//             : "Not Verified"}
//         </span>
//       </div>

//       <div className={styles.equipmentDetails}>
//         <div className={styles.detailItem}>
//           <strong>Licence Number:</strong> <span>{license.licence_number}</span>
//         </div>
//         <div className={styles.detailItem}>
//           <strong>Training Institute Name:</strong>{" "}
//           <span>{license.institute_name}</span>
//         </div>
//         <div className={styles.detailItem}>
//           <strong>Training Authorization Number:</strong>{" "}
//           <span>{license.authorisation_number}</span>
//         </div>
//         <div className={styles.detailItem}>
//           <strong>VLOS / BVLOS:</strong> <span>{license.vlos_bvlos}</span>
//         </div>
//         <div className={styles.detailItem}>
//           <strong>Class of UAS:</strong> <span>{license.uas_class}</span>
//         </div>
//         <div className={styles.detailItem}>
//           <strong>Category of UAS:</strong> <span>{license.uas_category}</span>
//         </div>
//         <div className={styles.detailItem}>
//           <strong>Issue Date:</strong> <span>{license.licence_issue}</span>
//         </div>
//         <div className={styles.detailItem}>
//           <strong>Expiry Date:</strong> <span>{license.licence_expiry}</span>
//         </div>
//       </div>
//       {showDeleteModal && (
//         <DeleteBox
//           deleteFunction={handleDelete}
//           isSuccess={licenseDeleted}
//           isError={deletionError}
//           contentName={license.title}
//           setShowDeleteModal={setShowDeleteModal}
//         />
//       )}
//     </div>
//   );
// };

// export default LicenseDetails;

import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styles from "../CommonStyles/commonstylesDetails.module.scss";
import { useFetchPartnerDetails } from "../../../../hooks/partnerHook/usePartner";
import { useRemoveLicence } from "../../../../hooks/partnerHook/usePartnerLicence";
import { RiMore2Fill } from "react-icons/ri";
import DeleteBox from "../../../../components/DeleteBox/DeleteBox";
import { Menu, MenuItem } from "@mui/material";

const LicenseDetails = () => {
  const { licenceId } = useParams();
  const navigate = useNavigate();
  const { data: partnerData, isLoading, isError } = useFetchPartnerDetails();

  const license = partnerData?.partner?.licence?.find(
    (lic) => lic.licence_id.toString() === licenceId
  );
  

  const {
    mutate: removeLicense,
    isSuccess: licenseDeleted,
    isError: deletionError,
  } = useRemoveLicence();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    navigate(`/dashboard/licenses/edit-licence/${licenceId}`);
    handleMenuClose();
  };

  const handleDelete = () => {
    if (licenceId) {
      removeLicense({ partnerId: partnerData.partner.id, licenceId });
      setShowDeleteModal(false);
      navigate("/dashboard/licenses");
    }
  };

  if (isLoading) return <h2>Loading License Details...</h2>;
  if (isError || !license) return <h2>Error: License not found!</h2>;

  return (
    <div className={styles.detailsContainer}>
      <div className={styles.titleContainer}>
        <h2 className={styles.equipmentTitle}>{license.title}</h2>
        <div>
          <RiMore2Fill
            className={styles.deleteIcon}
            onClick={handleMenuClick}
          />
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem onClick={handleEdit}>Edit</MenuItem>
            <MenuItem
              onClick={() => {
                setShowDeleteModal(true);
                handleMenuClose();
              }}
            >
              Delete
            </MenuItem>
          </Menu>
        </div>
      </div>

      <div className={styles.imageCard}>
        <img
          src={license.media?.[0]?.media_url || "/default-image.jpg"}
          alt={license.title}
          className={styles.equipmentImage}
        />
        <span
          className={`${styles.verificationStatus} ${
            license.verification_status === "success"
              ? styles.verified
              : styles.notVerified
          }`}
        >
          {license.verification_status === "success"
            ? "Verified"
            : "Not Verified"}
        </span>
      </div>

      <div className={styles.equipmentDetails}>
        <div className={styles.detailItem}>
          <strong>Licence Number:</strong> <span>{license.licence_number}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Training Institute Name:</strong>{" "}
          <span>{license.institute_name}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Training Authorization Number:</strong>{" "}
          <span>{license.authorisation_number}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>VLOS / BVLOS:</strong> <span>{license.vlos_bvlos}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Class of UAS:</strong> <span>{license.uas_class}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Category of UAS:</strong> <span>{license.uas_category}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Issue Date:</strong> <span>{license.licence_issue}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Expiry Date:</strong> <span>{license.licence_expiry}</span>
        </div>
      </div>
      {showDeleteModal && (
        <DeleteBox
          deleteFunction={handleDelete}
          isSuccess={licenseDeleted}
          isError={deletionError}
          contentName={license.title}
          setShowDeleteModal={setShowDeleteModal}
        />
      )}
    </div>
  );
};

export default LicenseDetails;
